import React, { Component } from 'react';
import flow from 'lodash/flow';
import Button from '@atlaskit/button';
import AppIcon from '@atlaskit/icon/core/app';
import { token } from '@atlaskit/tokens';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import { type IntlShape, injectIntl } from '@atlassian/jira-intl/src/index.tsx';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { ChannelStatusLozenge, LOZENGE_TYPES } from '../../status-lozenge/index.tsx';
import { BaseChannelItem, ChannelItemImage } from '../index.tsx';
import { WidgetDisabledIcon, WidgetEnabledIcon } from './assets/index.tsx';
import messages from './messages.tsx';

type Props = {
	isEnabled: boolean;
	isAdmin: boolean;
	link: string;
	onClick: () => void;
	intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
class WidgetChannelViewComponent extends Component<Props> {
	disabledImage = (
		<ChannelItemImage>
			<WidgetDisabledIcon />
		</ChannelItemImage>
	);

	enabledImage = (
		<ChannelItemImage>
			<WidgetEnabledIcon />
		</ChannelItemImage>
	);

	render() {
		const {
			isEnabled,
			isAdmin,
			onClick,
			link,
			intl: { formatMessage },
		} = this.props;
		const configureButton = (
			<Button
				href={link}
				onClick={onClick}
				appearance="default"
				{...(fg('jsm_aiiy_for_nav_item_channel')
					? { 'aria-label': formatMessage(messages.configureLabelDescriptive) }
					: {})}
			>
				{formatMessage(messages.configure)}
			</Button>
		);

		const lozengeType = isEnabled ? LOZENGE_TYPES.ON : LOZENGE_TYPES.OFF;
		const lozengeLabel = formatMessage(
			isEnabled ? messages.widgetOnLabel : messages.widgetOffLabel,
		);
		const isNav4 = getWillShowNav4();

		const description = isEnabled
			? formatMessage(isNav4 ? messages.widgetOn : messages.channelIsOn)
			: formatMessage(isNav4 ? messages.widgetOff : messages.channelTurnedOff);

		const image = isEnabled ? this.enabledImage : this.disabledImage;
		const icon = isNav4 ? <AppIcon color={token('color.icon')} label="" /> : image;

		const label = isNav4 ? formatMessage(messages.widget) : formatMessage(messages.widgetLabel);

		return (
			<BaseChannelItem
				button={isAdmin ? configureButton : undefined}
				image={icon}
				label={label}
				description={description}
				channelName="widget"
				statusLozenge={!isNav4 && <ChannelStatusLozenge type={lozengeType} label={lozengeLabel} />}
			/>
		);
	}
}

export const WidgetChannelView = flow(
	withFireUiAnalytics({
		onClick: 'configureWidget',
	}),
	injectIntl,
)(WidgetChannelViewComponent);
